import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import RichTextEditor from '../RichTextEditor';

interface CommunityFormProps {
    ticket_group_code: string;
    items: Item[];
    button_name: string;
    url: string;
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onButtonNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onUrlChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

interface Item {
    ticket_id: number;
    ticket_group_code: string;
    // Add more properties as per your item structure
}

export default function TicketGroupCode({
    items,
    ticket_group_code,
    button_name,
    url,
    onTicketGroupCodeChange,
    onButtonNameChange,
    onUrlChange
}: CommunityFormProps) {
    
    return (
        <>
            <h2 className='mb-5 font-semibold'></h2>
            <Form.Group className="mb-3" controlId="formCategory">
                <label className='text-sm mb-2'>Ticket Group Code</label>
                <Form.Select aria-label="Select Category" className='bg-gray-200' 
                value={ticket_group_code} onChange={onTicketGroupCodeChange}>

                    <option value=""> Select Ticket Group Code</option>
                    {items.map((item) => (
                        <option key={item.ticket_id} value={item.ticket_group_code}>
                            {item.ticket_group_code}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>


            <Form.Group className="mb-3" controlId="formTier">
                <label className='text-sm mb-2'>Button Name</label>
                <FloatingLabel controlId="floatingInput" label="Button Name" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Tier"
                        value={button_name}
                        className='bg-gray-200'
                        onChange={onButtonNameChange}
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formUrl">
                <label className='text-sm mb-2'>Url</label>
                <FloatingLabel controlId="floatingInput" label="Url" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Currency"
                        value={url}
                        className='bg-gray-200'
                        onChange={onUrlChange}
                    />
                </FloatingLabel>
            </Form.Group>
        </>
    );
}
